import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CdkDragDrop, CdkDrag, CdkDropList, moveItemInArray, DragDropModule } from '@angular/cdk/drag-drop';
import { CardWidgetComponent } from '../../components/card-widget/card-widget.component';
import { AddWidgetsComponent } from "../../components/add-widgets/add-widgets.component";
import { WIDGET } from '../../../../shared/interfaces/widget';
import { DataService } from '../../../../services/dashboard/data.service';
import { ActivatedRoute } from '@angular/router';
import { ModalActivitiesSelectionComponent } from "./components/modal-activities-selection/modal-activities-selection.component";
import { RecentViewedList } from '../../../../shared/interfaces/home-recent-viewed';
import { RecentlyViewedComponent } from '../../home/components/recently-viewed/recently-viewed.component';
import { GenerateNationalReportComponent } from './components/generate-national-report/generate-national-report.component';
import { Router } from '@angular/router';
import { DmtUtilityService } from '../../../../services/dashboard/dmt-utility.service';

@Component({
  selector: 'app-national',
  imports: [CdkDropList, CdkDrag, CommonModule, CardWidgetComponent, AddWidgetsComponent, DragDropModule, ModalActivitiesSelectionComponent, GenerateNationalReportComponent],
  templateUrl: './national.component.html',
  styleUrl: './national.component.css'
})
export class NationalComponent implements OnInit {

  isAddWidgetsOpen: boolean = false;
  allWidgets: WIDGET[] = [];
  selectedWidgets: WIDGET[] = [];

  isEditMode: boolean = false;
  isDragging: boolean = false;

  companyId: number | null = null;
  isModalActivitiesOpen: boolean = false;
  isAccessCurveOpen: boolean = false;
  isMarketCurveOpen: boolean = false;
  toRecentlyViewed: RecentViewedList = {} as RecentViewedList;
  medicineId?: number;
  medicineInfo: any;
  medicineName: string | null = '';


  isGenerateNationalPPTModuleOpen: boolean = false;

  constructor (
    private dataService: DataService,
    private route: ActivatedRoute,
    private router: Router,
    private us: DmtUtilityService
  ) { }

  ngOnInit (): void {

    // send event to open platform to the user in the sidebar
    window.dispatchEvent(new CustomEvent('isDashboardOpen', { detail: true }));
    window.dispatchEvent(new CustomEvent('inWhichPage', { detail: "NATIONAL" }));

    sessionStorage.setItem("solution", "Territorial");

    const id = Number(this.route.snapshot.paramMap.get('id'));

    this.allWidgets = this.dataService.defaultWidgetsInDashboard;
    //console.log("ALLWIDGETS:",this.allWidgets)
    this.selectedWidgets = this.allWidgets.filter(widget => widget.onDashboard);
    this.checkWidgetsLayout();

    const companyIdString = sessionStorage.getItem('companyId');
    this.companyId = companyIdString ? parseInt(companyIdString, 10) : null;
    this.dataService.actualCompanyId = this.companyId;
    this.dataService.actualMedicineId = id;

    this.medicineId = this.dataService.actualMedicineId;
    this.medicineName = sessionStorage.getItem('businessName');

    if (this.companyId !== null) {
      this.dataService.getMedicinesByCompanyId(this.companyId).subscribe({
        next: medicines => {
          const medicine = medicines.find(m => m.id === id);
        },
        error: err => {
          console.error('Errore nel caricamento:', err);
        }
      });
    }
    this.buildRecentViewed();

  }

  /** To build the recent viewed to send to the data service  */
  buildRecentViewed () {
    if (this.toRecentlyViewed.url?.solution === 'national') return;

    this.toRecentlyViewed.title = 'Nazione';
    this.toRecentlyViewed.medicineName = sessionStorage.getItem('businessName') || '';
    this.toRecentlyViewed.date = new Date().toLocaleString('sv-SE', { timeZone: 'Europe/Rome' });
    this.toRecentlyViewed.type = 'nation';

    if (this.medicineId != null) {
      this.toRecentlyViewed.url = {
        solution: 'territorial',
        medicineId: this.medicineId
      };
    }

    const username = sessionStorage.getItem('username') || '';
    const companyId = this.us.getSessionVariableNumber('companyId', 0);

    this.dataService.addToRecentViewed(this.toRecentlyViewed, username, companyId);
  }

  private checkWidgetsLayout (): void {
    setTimeout(() => {
      const container = document.querySelector('[cdkDropList]');
      if (!container) return;

      const children = Array.from(container.children) as HTMLElement[];
      // Resetta goLarge a false per tutti i widget
      this.selectedWidgets = this.selectedWidgets.map(w => ({ ...w, goLarge: false }));

      // Funzione per trovare una chiave top “vicina” già presente in rows, con tolleranza
      function findCloseTopKey (rows: Record<number, any>, top: number, tolerance = 50): number | null {
        for (const keyStr of Object.keys(rows)) {
          const key = Number(keyStr);
          if (Math.abs(key - top) <= tolerance) {
            return key;
          }
        }
        return null;
      }

      const rows: Record<number, { fixed: number[], notFixed: number[] }> = {};

      children.forEach((child, idx) => {
        const widget = this.selectedWidgets[idx];
        if (!widget) return;

        const top = child.offsetTop;
        const topKey = findCloseTopKey(rows, top, 500) ?? top;

        if (!rows[topKey]) {
          rows[topKey] = { fixed: [], notFixed: [] };
        }

        if (widget.fixedWidth) {
          rows[topKey].fixed.push(widget.id);
        } else {
          rows[topKey].notFixed.push(widget.id);
        }
      });

      Object.keys(rows).forEach(top => {
        const row = rows[+top];

        // Se ci sono sia fixed che notFixed in riga, i notFixed diventano goLarge true
        if (row.fixed.length > 0 && row.notFixed.length > 0) {
          this.selectedWidgets = this.selectedWidgets.map(w => {
            if (row.notFixed.includes(w.id)) {
              return { ...w, goLarge: true };
            }
            return w;
          });
        }

        // Se ci sono più di un notFixed sulla stessa riga, tutti loro vanno a goLarge false (override)
        if (row.notFixed.length > 1) {
          this.selectedWidgets = this.selectedWidgets.map(w => {
            if (row.notFixed.includes(w.id)) {
              return { ...w, goLarge: false };
            }
            return w;
          });
        }


        // Se ce' un solo notfixed si allarga
        if (row.notFixed.length == 1) {
          this.selectedWidgets = this.selectedWidgets.map(w => {
            if (row.notFixed.includes(w.id)) {
              return { ...w, goLarge: true };
            }
            return w;
          });
        }
      });

      this.selectedWidgets = [...this.selectedWidgets];
    }, 0);


  }

  drop (event: CdkDragDrop<any[]>) {
    if (event.previousIndex !== event.currentIndex) {
      moveItemInArray(this.selectedWidgets, event.previousIndex, event.currentIndex);

      this.dataService.defaultWidgetsInDashboard = this.dataService.defaultWidgetsInDashboard.map(widget => {
        const isOnDashboard = this.selectedWidgets.some(sw => sw.id === widget.id);
        return { ...widget, onDashboard: isOnDashboard };
      });

      this.selectedWidgets = [...this.selectedWidgets];
      this.checkWidgetsLayout();
    }
  }

  onWidgetsUpdated (updated: WIDGET[]) {
    this.allWidgets = updated;
    this.selectedWidgets = this.allWidgets.filter(w => w.onDashboard);
    this.dataService.defaultWidgetsInDashboard = this.allWidgets;
    this.checkWidgetsLayout();
  }

  onDeleteWidget (widgetId: number) {
    this.allWidgets = this.allWidgets.map(w =>
      w.id === widgetId ? { ...w, onDashboard: false } : w
    );

    this.selectedWidgets = this.allWidgets.filter(w => w.onDashboard);
    this.dataService.defaultWidgetsInDashboard = this.allWidgets;
    this.checkWidgetsLayout();
  }

  trackById (index: number, item: any): number {
    return item.id;
  }

  openAddWidgets () {
    this.isAddWidgetsOpen = true;
    // this.isEditMode = false;
    document.body.style.overflow = 'hidden';
    document.body.style.width = '100%';
  }

  openModalAddWidgetsFromChild (event: boolean): void {
    this.isAddWidgetsOpen = event;
    document.body.style.overflow = '';
    document.body.style.width = '';
  }

  toggleEditMode (status: boolean) {
    this.isEditMode = status;
  }

  handleModalActivitiesToggle (value: boolean) {
    this.isModalActivitiesOpen = value;

    if (this.isModalActivitiesOpen) {
      document.body.style.overflow = 'hidden';
      document.body.style.width = '100%';
    } else {
      document.body.style.overflow = '';
      document.body.style.width = '';
    }
  }

  onOpenAccessCurveFromWidget (value: boolean) {
    this.isAccessCurveOpen = value;

    if (this.isAccessCurveOpen) {
      document.body.style.overflow = 'hidden';
      document.body.style.width = '100%';
    } else {
      document.body.style.overflow = '';
      document.body.style.width = '';
    }
  }

  onOpenMarketCurveFromWidget (value: boolean) {
    this.isMarketCurveOpen = value;
    if (this.isMarketCurveOpen) {
      document.body.style.overflow = 'hidden';
      document.body.style.width = '100%';
    } else {
      document.body.style.overflow = '';
      document.body.style.width = '';
    }
  }

  onShowGenNationalPPTModal (): void {
    console.log('Get medicine info for ID:', this.medicineId);
    this.dataService.getMedicineInfoById(this.medicineId || 0).subscribe({
      next: (medicineInfo) => {
        console.log('Medicine Info:', medicineInfo);
        this.medicineInfo = medicineInfo;
      },
      error: (error) => {
        console.error('Error fetching medicine info:', error);
      }
    });
  }

  handleModalChange (value: boolean) {
    this.isGenerateNationalPPTModuleOpen = value;
    if (GenerateNationalReportComponent) {

      this.onShowGenNationalPPTModal();
    }

    if (this.isGenerateNationalPPTModuleOpen) {
      document.body.style.overflow = "hidden";
      document.body.style.width = "100%";
    } else {
      document.body.style.overflow = "";
      document.body.style.width = "";
    }
  }
}